import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"
import { StoreDetail } from "@/features/stores/components"
import { storeDetailQuery } from "@/features/stores/core/hooks/useStoreDetail"

const Params = z.object({
  storeId: z.string(),
})

export const Route = createFileRoute("/(authenticated)/settings/stores/$storeId")({
  params: Params,
  loader: ({ context, params }) => {
    void context.queryClient.ensureQueryData(storeDetailQuery(params))
  },
  component: () => {
    const { storeId } = Route.useParams()
    return <StoreDetail storeId={storeId} />
  },
})
